<template>
  <div ref="menuContainer" role="menu">
    <slot></slot>
  </div>
</template>

<script>
import { findFirstFocusableElement } from '@utils/focus'
import { keyEvents } from '@utils/keyevents'

export default {
  name: 'FlotoActionMenuWrapper',
  data() {
    this.DROPDOWN_ACTIVE_MENU_ITEM_CLASS = 'ant-dropdown-menu-item-active'
    this.ACTION_MENU_ID = 'action-menu-child'
    return {
      menuItems: [],
      menu: null,
    }
  },
  methods: {
    updateMenuItems(globalData) {
      setTimeout(() => {
        this.$nextTick(() => {
          const menuContainer = globalData.$refs.menuContainerRef.$el
          this.menu = menuContainer
          if (globalData.$refs.menuContainerRef) {
            this.menuItems = Array.from(
              menuContainer.querySelectorAll('[role="menuitem"]')
            )

            if (this.menuItems.length > 0) {
              this.menuItems[0].setAttribute('tabindex', '0')

              this.menuItems[0].focus()
              menuContainer.addEventListener('keydown', this.handleKeydown)
            }
          }
        })
      }, 200)
    },
    handleKeydown(event) {
      if (!this.menuItems.length) return
      if (event.key === keyEvents.ENTER) {
        event.preventDefault()

        const activeMenuItem = this.menu.querySelector(
          `.${this.DROPDOWN_ACTIVE_MENU_ITEM_CLASS}`
        )

        const clickableElement = findFirstFocusableElement(activeMenuItem)

        if (clickableElement) clickableElement.click()
        else {
          const childMenuItem = activeMenuItem.querySelector(
            `#${this.ACTION_MENU_ID}`
          )
          if (childMenuItem) {
            childMenuItem.setAttribute('role', 'button')
            childMenuItem.click()
          }
        }
      }
    },
  },
}
</script>
